var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.5,
    height: 33.666,
    viewBox: "0 0 30.5 33.666",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-706.425 -1147.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M793.5,278H822",
    transform: "translate(-86.075 876.5)",
    fill: "none",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M817.334,281v22.167a3.166,3.166,0,0,1-3.167,3.165H798.334a3.166,3.166,0,0,1-3.167-3.165V281m4.75,0v-3.167a3.166,3.166,0,0,1,3.167-3.165h6.333a3.166,3.166,0,0,1,3.167,3.165V281",
    transform: "translate(-84.574 873.5)",
    fill: "none",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.46b85a39c4519176d6e0be6d49d94d0e.svg";
export { ForwardRef as ReactComponent };